export default __webpack_public_path__ + "static/media/cert-market-cpttm.beb0d652.jpg";